// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3zki5","inner":"Form_inner__2jmKG","range":"Form_range__2EFzA","name":"Form_name__2OuPH","actions":"Form_actions__2b1MM"};